import * as yup from 'yup'

export const approvalDetailsSchema = (t: any) =>
  yup.object().shape({
    comment: yup
      .string()
      .test(
        'min-length-if-not-empty',
        t('approvalDetail.commentMinRequiredStart', { min: 3 }) as string,
        (value) => !value || value.trimStart().length >= Number(3)
      )
      .required(t('approvalDetail.commentRequiredStart') as string),
    sendPreNotice: yup.boolean(),
  })
